<template>
  <div>
    <template v-if="useRequestPoints">
      <RequestPoints v-model="viewRequestPoints" />
    </template>
    <template v-if="usePointHistory">
      <PointHistory v-model="viewPointHistory" />
    </template>
    <template v-if="useHowToScore">
      <HowToScore v-model="viewHowToScore" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, ref } from 'vue'
import { watchOnce } from '@vueuse/core'
import { useGame } from '@/composables/useGame'

const RequestPoints = defineAsyncComponent(() => import('./modals/requestPoints.vue'))
const PointHistory = defineAsyncComponent(() => import('./modals/pointHistory.vue'))
const HowToScore = defineAsyncComponent(() => import('./modals/howToScore.vue'))

const { viewRequestPoints, viewPointHistory, viewHowToScore } = useGame()

const useRequestPoints = ref(false)
watchOnce(viewRequestPoints, () => {
  useRequestPoints.value = true
})

const usePointHistory = ref(false)
watchOnce(viewPointHistory, () => {
  usePointHistory.value = true
})

const useHowToScore = ref(false)
watchOnce(viewHowToScore, () => {
  useHowToScore.value = true
})
</script>